var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "currentColor",
    d: "M 28 16.073 C 28 9.445 22.627 4.073 16 4.073 C 9.373 4.073 4 9.445 4 16.073 C 4 22.062 8.388 27.027 14.125 27.927 L 14.125 19.542 L 11.078 19.542 L 11.078 16.073 L 14.125 16.073 L 14.125 13.429 C 14.125 10.422 15.917 8.76 18.658 8.76 C 19.97 8.76 21.344 8.995 21.344 8.995 L 21.344 11.948 L 19.831 11.948 C 18.34 11.948 17.875 12.873 17.875 13.823 L 17.875 16.073 L 21.203 16.073 L 20.671 19.542 L 17.875 19.542 L 17.875 27.927 C 23.612 27.027 28 22.062 28 16.073 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.ef27653f4fa789c0d0e22700fe3ac0f2.svg";
export { ForwardRef as ReactComponent };